import { Box, Stack, Typography } from '@mui/material'
import { RequestRow } from '@omnea-app/fe-requests/useRequestTableRows'
import { TaskRow } from '@omnea-app/fe-tasks/useTaskTableRows'
import { StyledSkeleton } from '@omnea-app/frontend/components/layout/skeleton/StyledSkeleton'
import { useShowCardsOnDashboard } from '../../hooks/useShowCardsOnDashboard'
import { DashboardDataGrid } from './DashboardDataGrid'
import { MobileCards } from './MobileCards'
import { NoRequestsAvailable } from './NoRequestsAvailable'
import type { SortModel } from './sortRows'
import type { DashboardTableType } from './types'

interface DashboardApprovalSectionProps {
  type: DashboardTableType
  rows: TaskRow[] | RequestRow[]
  loading: boolean
  title: string
  visibleColumns: string[]
  showNewRequestButtonIfEmpty?: boolean
  defaultSortModel?: SortModel
}

export const DashboardTable = ({
  rows,
  type,
  loading,
  title,
  showNewRequestButtonIfEmpty,
  visibleColumns,
  defaultSortModel,
}: DashboardApprovalSectionProps) => {
  const showCards = useShowCardsOnDashboard()
  return (
    <Stack gap={5} sx={{ width: '100%' }}>
      {loading ? (
        <Box sx={{ pb: 2 }}>
          <StyledSkeleton height={28} width={231} />
        </Box>
      ) : (
        <Typography variant="H6Semibold">{title}</Typography>
      )}
      <Stack width="100%" sx={{ flex: 1 }}>
        {rows.length > 0 &&
          (showCards ? (
            <MobileCards rows={rows} type={type} defaultSortModel={defaultSortModel} />
          ) : (
            <DashboardDataGrid rows={rows} defaultSortModel={defaultSortModel} type={type} visibleColumns={visibleColumns} />
          ))}
        {rows.length === 0 && !loading && <NoRequestsAvailable showNewRequestButton={showNewRequestButtonIfEmpty} type={type} />}
      </Stack>
    </Stack>
  )
}
